import React from 'react';
import { PDFViewer, PDFDownloadLink, Document, Page, Text, View, Image } from '@react-pdf/renderer';
import { Button } from "@nextui-org/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import logo from '../images/logo.png'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
const MyDocument = ({ data,alt_data }) => (

  <Document>
    
    <Page>
      <View>
        <Image src={logo} style={{ width: "15%", padding: "1vh" }} />
      </View>

      {data && data.type_of_req == "add_data" ?
        <>
          <View style={{ display: "flex", alignItems: "center" }}>
            <Text style={{ color: "#F7941E" }}>Request of Adding{data && (
              data.table_name === "user_has_policy" ? (
                <> Policy</>
              ) : (
                <> {data.table_name}</>
              )
            )}</Text>
          </View>
          <View style={{ padding: "20" }}>
            <Text style={{ fontStyle: "bold", fontSize: "12" }}>Full Name  : {data.name}</Text>
            <Text style={{ fontStyle: "bold", fontSize: "12" }}>NIC : {data.nic}</Text>
            <Text style={{ fontStyle: "bold", fontSize: "12" }}>Contact Number : {data.mobile}</Text>
            
          </View>
          <View style={{ paddingLeft: "15" }}>
            <Text style={{ color: "#13B1F1", fontSize: "15" }}>New  {data && (
              data.table_name === "user_has_policy" ? (
                <> Policy</>
              ) : (
                <> {data.table_name}</>
              )
            )} Info :</Text>
          </View>
          <View>
            <View style={{ display: "flex", alignItems: "center" }}>


              <View style={{ padding: "10" }}  >
                <Text style={{ fontStyle: "bold", fontSize: "12" }}>Full Name  : {data.req_full_name}</Text>
                <Text style={{ fontStyle: "bold", fontSize: "12" }}>NIC : {data.req_nic}</Text>
                <Text style={{ fontStyle: "bold", fontSize: "12" }}>Birthday : {data.req_birthday}</Text>
                <Text style={{ fontStyle: "bold", fontSize: "12" }}>Relationship  : {data.req_birthday}</Text>


              </View>


            </View>


          </View>

        </>

        :
        null}
         {data && data.type_of_req == "alteration_data" ?
        <>
          <View style={{ display: "flex", alignItems: "center" }}>
            <Text style={{ color: "#F7941E" }}>Request of Altering {data && (
              data.table_name === "user_has_policy" ? (
                <> Policy</>
              ) : (
                <> {data.table_name}</>
              )
            )}</Text>
          </View>
          <View style={{ padding: "20" }}>
            <Text style={{ fontStyle: "bold", fontSize: "12" }}>Full Name  : {data.name}</Text>
            <Text style={{ fontStyle: "bold", fontSize: "12" }}>NIC : {data.nic}</Text>
            <Text style={{ fontStyle: "bold", fontSize: "12" }}>Contact Number : {data.mobile}</Text>
            
          </View>
          <View style={{ paddingLeft: "15" }}>
            <Text style={{ color: "#13B1F1", fontSize: "15" }}>New  {data && (
              data.table_name === "user_has_policy" ? (
                <> Policy</>
              ) : (
                <> {data.table_name}</>
              )
            )} Info :</Text>
          </View>
          <View>
            <View style={{ display: "flex", alignItems: "center" }}>

          {
            alt_data?.map((value)=>{
              return(
                <>
               <Text style={{ fontStyle: "bold", fontSize: "15" }}>{value.req_type}</Text>
              <View style={{ padding: "10" }}  >

                <Text style={{ fontStyle: "bold", fontSize: "12" }}>Req Id  : {value.req_id}</Text>
                <Text style={{ fontStyle: "bold", fontSize: "12" }}>Old Data : {value.old_data}</Text>
                <Text style={{ fontStyle: "bold", fontSize: "12" }}>New Data : {value.new_data}</Text>
              


              </View>
                </>
              )


            })
          }


            </View>


          </View>

        </>

        :
        null}
    </Page>
  </Document>
);

function RequestPdf(data) {
  const { data: req_data,alt_data } = data

  return (
    <div>


      {/* PDFDownloadLink for downloading the PDF */}
      <PDFDownloadLink document={<MyDocument data={req_data} alt_data={alt_data}/>} fileName={`request_doc_${req_data && req_data.id}.pdf`}>
        {({ blob, url, loading, error }) =>
          loading ?
            <Button isLoading style={{ color: "white", backgroundColor: "#F5190E" }} >

            </Button>

            :
            <Button isIconOnly style={{ color: "white", backgroundColor: "#F5190E" }} >
              <FontAwesomeIcon icon={faFilePdf} style={{ height: "2.5vh" }} />
            </Button>
        }
      </PDFDownloadLink>
    </div>
  )
    ;
}

export default RequestPdf;
